export default __webpack_public_path__ + "static/media/product-tour0.4dcd1d32.svg";